// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** St. Lucia */
const LC: PhoneNumberData = [1, 'LC', 10, format0, /^(?:758)/];

export default LC;
